import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { PessoaDomain } from '@/core/api/sicom-api/registro/pessoa/pessoa.domain';
import { ReturnRouteService } from '@/core/services/return-route.service';
import { PessoaService } from '@/shared/services/pessoa.service';

export type PrestadorFinanceiroReturnContext = {
    id: string;
    returnUrl: string;
    label?: string;
};

export const COMISSOES_FINANCEIRO_RETURN_CONTEXT_ID = 'comissoes-financeiro';
export const COMPOSICAO_FINANCEIRO_RETURN_CONTEXT_ID = 'composicao-financeiro';
export const DIRETORIA_FINANCEIRO_RETURN_CONTEXT_ID = 'diretoria-financeiro';
export const SERVICOS_FINANCEIRO_RETURN_CONTEXT_ID = 'servicos-financeiro';

@Injectable({ providedIn: 'root' })
export class PrestadorFinanceiroNavigationService {
    constructor(
        private readonly pessoaService: PessoaService,
        private readonly returnRouteService: ReturnRouteService,
        private readonly router: Router
    ) {}

    abrirMedico(prestadorAtual: PessoaDomain | undefined, medico: PessoaDomain, contexto: PrestadorFinanceiroReturnContext): void {
        if (!prestadorAtual?.id || !prestadorAtual.uf || !medico.id || !medico.uf) {
            return;
        }

        this.returnRouteService.registrar({
            id: contexto.id,
            label: contexto.label ?? 'Voltar para Prestadores',
            returnUrl: contexto.returnUrl,
            createdFromUrl: contexto.returnUrl,
            payload: prestadorAtual
        });
        this.pessoaService.setPessoa(medico);
        void this.router.navigate(['/arrecadacao', 'dashboard', 'pagamentos'], { queryParams: { returnContext: contexto.id } });
    }
}
